export default __webpack_public_path__ + "static/media/linkedin.e5bc1d89.svg";